/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News manage delete news confirm
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import type { FC } from 'react';

import { Button } from '@nexign/scc-ui-kit';
import { useSelector } from 'react-redux';

import { icons } from '@assets/index';
import { ImgStyled } from '@components/common/Block/Img';
import { makeSelectPageNewsTranslation, makeSelectTranslationCommon } from '@modules/internationalization/intSelectors';
import Modal from '@modules/modal/components/Modal';
import { ModalTitleStyled, ModalTitleTextStyled } from '@modules/modal/components/styled/ModalStyled';
import { EModalStatus } from '@modules/modal/types/modalTypes';

interface IProps {
    onCloseModal: () => void;
    handleOk: () => void;
}

export const NewsCancelModal: FC<IProps> = ({ handleOk, onCloseModal }) => {
    const tCommon = useSelector(makeSelectTranslationCommon());
    const {
        modals: { cancelModal: tCancelModal },
    } = useSelector(makeSelectPageNewsTranslation());

    return (
        <Modal dataName="news-item-delete-modal" style={{ padding: '24px' }} width="480px">
            <Modal.Title className="modal-popup-title__base">
                <ModalTitleStyled>
                    <ModalTitleTextStyled>{tCancelModal.title}</ModalTitleTextStyled>
                    <ImgStyled height="16px" src={icons.cancelSmallIcon} width="16px" onClick={onCloseModal} />
                </ModalTitleStyled>
            </Modal.Title>
            <Modal.Status status={EModalStatus.start}>
                <Modal.Text>{tCancelModal.text}</Modal.Text>
                <Modal.Control className="modal-popup-control__base margin-between">
                    <Button size="small" typographyProps={{ variant: 'h5' }} onClick={handleOk}>
                        {tCommon.modal.ok}
                    </Button>
                    <Button color="info" size="small" variant="text" onClick={onCloseModal}>
                        {tCommon.modal.cancel}
                    </Button>
                </Modal.Control>
            </Modal.Status>
        </Modal>
    );
};
